import { Space } from 'antd';

import { Logo } from './components/Logo';
import { LogoutButton } from './components/LogoutButton';
import { UserInfo } from './components/UserInfo';

import { HeaderContainer } from './style';

export const Header = () => (
  <HeaderContainer>
    <Space>
      <Logo />
    </Space>
    <Space>
      <LogoutButton />
      <UserInfo />
    </Space>
  </HeaderContainer>
);
